module.exports = __webpack_public_path__ + "img/otp-code.92ccc268.jpg";